<template>
  <div :class="$style.cooperation">
    <div :class="$style.cooperationList">
      <div :class="$style.cooperationItem" :key="index" v-for="(item, index) in cooperationList.slice(0, 5)">{{ item }}</div>
    </div>
    <div :class="$style.cooperationList">
      <div :class="$style.cooperationItem" :key="index" v-for="(item, index) in cooperationList.slice(5)">{{ item }}</div>
    </div>
  </div>
</template>

<script>
import { cooperationList } from './data'

export default {
  data () {
    return {
      cooperationList
    }
  }
}
</script>

<style lang="scss" module>
.cooperation {
  box-sizing: border-box;
  width: 1200px;
  height: 144px;
  margin-top: 32px;
  padding: 32px 70px;
  background: rgba(189, 215, 255, .2);
  border-radius: 12px;
}

.cooperationList {
  display: flex;
  justify-content: space-between;

  &:last-child {
    padding: 0 150px;
  }
}

.cooperationItem {
  position: relative;
  margin-bottom: 30px;
  padding: 0 20px;
  font-size: 18px;
  font-weight: 500;
  color: #4289FF;
  line-height: 25px;

  &:last-child {
    margin-right: 0;
  }

  &:before,
  &:after {
    content: '';
    position: absolute;
    top: 0;
    width: 14px;
    height: 26px;
  }

  &:before {
    left: 0;
    background: url(../../assets/img/number/plume-l.png) no-repeat center / 14px 26px;
  }

  &:after {
    right: 0;
    background: url(../../assets/img/number/plume-r.png) no-repeat center / 14px 26px;
  }
}
</style>
